/**
 * Component: user-details
 */
<template language="javascript">
  <div class="container-fluid container-ticket-details">
    <div class="icon-spinner-grey" v-if="isLoading"></div>
    <div v-if="!isLoading">
      <div class="row">
        <div class="col form-group">
          <label for="userDetailsName">Nombre</label>
          <input type="text" class="form-control" id="userDetailsName" v-model="name" v-bind:class="{ 'is-invalid': fieldErrors.name }">
          <p v-if="fieldErrors.name">{{ fieldErrors.name[0] }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <label for="userDetailsEmail">E-mail</label>
          <input type="text" class="form-control" id="userDetailsEmail" v-model="email" :class="{ 'is-invalid': fieldErrors.email }">
          <p v-if="fieldErrors.email">{{ fieldErrors.email[0] }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <label for="userDetailsPhone">Teléfono</label>
          <input type="text" class="form-control" id="userDetailsPhone" v-model="phone" :class="{ 'is-invalid': fieldErrors.phone }">
          <p v-if="fieldErrors.phone">{{ fieldErrors.phone[0] }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <label for="userDetailsRoleRef">Rol</label>
          <select class="form-select"  id="userDetailsRoleRef" v-model="roleRef" :class="{ 'is-invalid': fieldErrors.roleRef }">
            <option value=""></option>
            <option v-for="roleRefOption in roleRefOptions" :value="roleRefOption.value">{{ roleRefOption.label }}</option>
          </select>
          <p v-if="fieldErrors.roleRef">{{ fieldErrors.roleRef[0] }}</p>
        </div>
      </div>
      <div class="row" v-if="roleRef == roleRefCliente">
        <div class="col form-group">
          <label for="userEdificioId">Edificio</label>
          <select class="form-select"  id="userEdificioId" v-model="edificioId" :class="{ 'is-invalid': fieldErrors.edificioId }">
            <option value=""></option>
            <option v-for="edificioIdOption in edificioIdOptions" :value="edificioIdOption.value">{{ edificioIdOption.label }}</option>
          </select>
          <p v-if="fieldErrors.edificioId">{{ fieldErrors.edificioId[0] }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <label for="userDetailsPassword">Contraseña</label>
          <input type="password" class="form-control" id="userDetailsPassword" v-model="password" :class="{ 'is-invalid': fieldErrors.password }">
          <p v-if="fieldErrors.password">{{ fieldErrors.password[0] }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <label for="userDetailsPassword_confirmation">Confirmar contraseña</label>
          <input type="password" class="form-control" id="userDetailsPassword_confirmation" v-model="password_confirmation" :class="{ 'is-invalid': fieldErrors.password }">
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <button class="btn btn-primary" v-on:click="submitForm">Enviar</button>
        </div>
      </div>
      <div class="row" v-if="messageContent">
        <div class="col">
          <div v-bind:class="{'alert': true, 'alert-success': messageType == 'success', 'alert-warning': messageType == 'alert', 'alert-danger': messageType == 'error' }">{{ messageContent }}</div>
        </div>
      </div>
      <div v-if="deleteUserUrl">
        <hr>
        <div class="row">
          <div class="col form-group">
            <button class="btn btn-secondary btn-sm" v-on:click="deleteThisUser">Borrar este usuario</button>
          </div>
        </div>
      </div>
    </div>
  </div><!--.container-fluid.container-ticket-details-->
</template>

<script>

import apiService from '../services/api-service.js';

export default {
  props: [
    "userId",
    "usersUrl",
    "deleteUserUrl",
    "roleRefCliente"
  ],
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      roleRef: "",
      edificioId: "",
      password: "",
      password_confirmation: "",
      isLoading: false,
      messageContent: "",
      messageType: "",
      fieldErrors: {}
    };
  },
  created(event) {
    this.getUser();
  },
  methods: {
    beginLoadingState(resetMessages) {
      if(resetMessages == null) {
        resetMessages = true;
      }
      this.isLoading = true;
      if(resetMessages) {
        this.messageType = ""; // success | alert | error
        this.messageContent = "";
        this.fieldErrors = {};
      }
    },
    endLoadingState(messageType, messageContent) {
      this.isLoading = false;
      if(messageType) {
        this.messageType = messageType;
      }
      if(messageContent) {
        this.messageContent = messageContent;
      }
    },
    getUser(resetMessages) {
      if(null === resetMessages) {
        resetMessages = true;
      }
      this.beginLoadingState(resetMessages);
      axios({
        method: "get",
        url: apiService.ajaxUrl + '-user/' + this.userId,
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          this.endLoadingState();
          this.name = response.data.name;
          this.email = response.data.email;
          this.phone = response.data.phone;
          this.roleRef = response.data.roleRef;
          this.roleRefOptions = response.data.roleRefOptions;
          this.edificioId = response.data.edificioId;
          this.edificioIdOptions = response.data.edificioIdOptions;
          // password is never retrieved
          /**
           * If we have just creeted a user, the hash 'new' will be present
           */
          if(window.location.hash) {
            if(window.location.hash == '#new') {
              this.messageType = 'success';
              this.messageContent = "Se ha creado un nuevo usuario";
              window.location.hash = '';
            }
          }
        } else if(response.data.status == apiService.STATUS_VALIDATION_FAILED) {
          this.endLoadingState("alert", response.data.message);
        } else {
          this.endLoadingState("error", response.data.message);
        }
      }).catch(error => {
        this.endLoadingState("error", "Error de conexión");
      });
    },
    submitUser() {
      this.beginLoadingState();
      axios({
        method: "post",
        url: apiService.ajaxUrl + '-user/' + this.userId,
        data: {
          name: this.name,
          email: this.email,
          phone: this.phone,
          roleRef: this.roleRef,
          edificioId: this.edificioId,
          password: this.password,
          password_confirmation: this.password_confirmation
        }
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          this.password = this.password_confirmation = "";
          if(this.userId == 0) {
            document.location.href = this.usersUrl+'/'+response.data.userId+'#new';
          } else {
            this.endLoadingState("success", response.data.message);
            this.getUser(false);
          }
        } else if(response.data.status == apiService.STATUS_VALIDATION_FAILED) {
          this.fieldErrors = response.data.errors;
          this.endLoadingState("alert", response.data.message);
        } else {
          this.endLoadingState("error", "Error: " + response.data.message);
        }
      }).catch(error => {
        this.endLoadingState("error", "Error de conexión");
      });
    },
    submitForm() {
      this.submitUser();
      return false;
    },
    deleteThisUser() {
      if(window.confirm("Está seguro de querer eliminar este usuario. Esta acción no se puede desacer.")) {
        document.location.href = this.deleteUserUrl;
      }
    }
  }
}
</script>
